import type { CartItem, DetailedSaleItem } from '@src/domains/cart';
import type { SaleTariff } from '@src/domains/sales';

export type FormattedTariffFormatter = (quantity: number, name: string) => string;

export type GetFormattedTariffsOptions = {
  format?: FormattedTariffFormatter;
};

const defaultFormat: FormattedTariffFormatter = (quantity, name) => `${name} (${quantity})`;

function isSaleTariff(tariff: unknown): tariff is SaleTariff {
  return 'unitPriceCurrencyInfo' in (tariff as SaleTariff) || 'unitPriceCents' in (tariff as SaleTariff);
}

export const getFormattedTariffs = (items: (CartItem | DetailedSaleItem)[], options?: GetFormattedTariffsOptions) => {
  const format = options?.format ?? defaultFormat;
  const tariffs = items.map((item) => item.tariffs).flat();

  const tariffGroups = tariffs.reduce((acc, tariff) => {
    const name = isSaleTariff(tariff) ? tariff.name : tariff.tariff.type.name;
    acc[name] = (acc[name] || 0) + tariff.quantity;
    return acc;
  }, {} as Record<string, number>);

  return Object.entries(tariffGroups)
    .map(([name, quantity]) => format(quantity, name))
    .join(', ');
};
